import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { MoreHorizontal, Pencil } from 'lucide-react'
import React from 'react'
import type { TransitionAction } from './career-path-types'

interface StageCardActionsProps {
    /** Transition actions to show in dropdown (skip/fail/offboard) */
    transitionActions: TransitionAction[]
    onTransition: (action: TransitionAction) => void
    onEdit: () => void
    t: (key: string) => string
}

const StageCardActions: React.FC<StageCardActionsProps> = ({
    transitionActions,
    onTransition,
    onEdit,
    t,
}) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button className="p-1.5 text-gray-400 hover:text-gray-600 rounded transition-colors">
                    <MoreHorizontal className="w-4 h-4" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                {/* Stage transition actions */}
                {transitionActions.map((action) => (
                    <DropdownMenuItem
                        key={action.key}
                        className={`cursor-pointer ${getActionColor(action.key)}`}
                        onClick={() => onTransition(action)}
                    >
                        {action.icon}
                        {action.label}
                    </DropdownMenuItem>
                ))}

                {transitionActions.length > 0 && <DropdownMenuSeparator />}

                {/* Edit */}
                <DropdownMenuItem className="cursor-pointer" onClick={onEdit}>
                    <Pencil className="w-4 h-4" />
                    {t('edit')}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}

/** Get text color class for dropdown action items */
const getActionColor = (actionKey: string): string => {
    switch (actionKey) {
        case 'skip':
            return 'text-blue-600 focus:text-blue-600'
        case 'fail':
            return 'text-red-600 focus:text-red-600'
        case 'offboard':
            return 'text-gray-600 focus:text-gray-600'
        default:
            return ''
    }
}

export default StageCardActions
